var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_32322_42885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.8334 14.6667C14.2016 14.6667 14.5001 14.3682 14.5001 14C14.5001 13.6319 14.2016 13.3334 13.8334 13.3334C13.4652 13.3334 13.1667 13.6319 13.1667 14C13.1667 14.3682 13.4652 14.6667 13.8334 14.6667Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.49992 14.6667C6.86811 14.6667 7.16658 14.3682 7.16658 14C7.16658 13.6319 6.86811 13.3334 6.49992 13.3334C6.13173 13.3334 5.83325 13.6319 5.83325 14C5.83325 14.3682 6.13173 14.6667 6.49992 14.6667Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.16675 0.666626H3.83341L5.62008 9.59329C5.68104 9.90022 5.84802 10.1759 6.09178 10.3722C6.33554 10.5684 6.64055 10.6726 6.95341 10.6666H13.4334C13.7463 10.6726 14.0513 10.5684 14.2951 10.3722C14.5388 10.1759 14.7058 9.90022 14.7667 9.59329L15.8334 3.99996H4.50008",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32322_42885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCart);
export default __webpack_public_path__ + "static/media/icon-cart.668ae486c8c44426dbf272f56daf9ff0.svg";
export { ForwardRef as ReactComponent };